import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ShipmentTransportOrderLoadsState } from './shipment-transport-order-loads.state';
import {
  ShipmentTransportOrderLoadsInitialState,
  ShipmentTransportOrderLoadsLoad,
} from './shipment-transport-order-loads.actions';
import { Injectable } from '@angular/core';
import { ShipmentTransportOrderLoadModel } from '../../models/shipment-transport-order-load.model';
import { TransportOrderIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderLoadsFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderLoadsState.getLoaded);
  loads$: Observable<ShipmentTransportOrderLoadModel[]> = this.store.select(ShipmentTransportOrderLoadsState.getLoads);

  constructor(private store: Store) {}

  loadAll(params: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderLoadsLoad(params));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderLoadsInitialState());
  }
}
